const NoReport_Icon = () => {
  return (
    <svg
      width="53"
      height="52"
      viewBox="0 0 53 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="26.5001"
        cy="25.9998"
        r="22.8333"
        stroke="#E5E5E5"
        stroke-width="2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.5 18C28.1569 18 29.5 16.6569 29.5 15C29.5 13.3431 28.1569 12 26.5 12C24.8431 12 23.5 13.3431 23.5 15C23.5 16.6569 24.8431 18 26.5 18ZM26.5 20C24.8431 20 23.5 21.3431 23.5 23V37C23.5 38.6569 24.8431 40 26.5 40C28.1569 40 29.5 38.6569 29.5 37V23C29.5 21.3431 28.1569 20 26.5 20Z"
        fill="#E5E5E5"
      />
    </svg>
  );
};

export default NoReport_Icon;
